import React, { useRef, useState } from 'react';
import { FormField, DatePicker } from '@wix/design-system';
import { BaseInputProps, BaseInputRef } from '../BaseInput';
import { Field } from '../Field';
import { dataHooks } from '../dataHooks';

export interface DateInputProps extends BaseInputProps<string> {}

export const DateInput = ({
  dataHook,
  schema,
  initialValue,
  inputRef,
  onChange,
}: DateInputProps) => {
  const [date] = useState(() =>
    initialValue ? new Date(initialValue) : undefined,
  );

  const ref = useRef<BaseInputRef>({});

  return (
    <Field dataHook={dataHook} type={schema.type}>
      <FormField dataHook={dataHooks.Label} label={schema.label}>
        <DatePicker
          ref={(internalRef) => {
            inputRef?.(ref.current);
            // TODO: PR to WSR needed to expose as public API
            // @ts-expect-error
            ref.current.focus = () => internalRef?.state?.inputRef?.focus?.();
          }}
          dataHook={dataHooks.Input}
          width="100%"
          value={date}
          validate
          onValidate={(payload) => {
            ref.current.invalid = payload.validationType !== 'valid';
          }}
          onChange={(newValue: Date) =>
            onChange(newValue.toISOString().split('T')[0])
          }
        />
      </FormField>
    </Field>
  );
};
